import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreLink?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreLink,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
            {title}
          </h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="shrink-0 text-sm font-label text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}